export function Skeleton({ className = '' }) {
  return <span className={`skeleton ${className}`} aria-hidden="true" />
}

export function EditorialListSkeleton({ count = 3 }) {
  return (
    <div className="editorial-list" aria-label="Chargement du contenu">
      {Array.from({ length: count }).map((_, index) => (
        <article className="editorial-row" key={index}>
          <Skeleton className="skeleton-image" />
          <div className="editorial-row__body">
            <Skeleton className="skeleton-line skeleton-line--small" />
            <Skeleton className="skeleton-line skeleton-line--title" />
            <Skeleton className="skeleton-line" />
            <Skeleton className="skeleton-line skeleton-line--short" />
          </div>
        </article>
      ))}
    </div>
  )
}

export function ArticleSkeleton() {
  return (
    <div className="long-read article-skeleton" aria-label="Chargement de l’article">
      <Skeleton className="skeleton-line skeleton-line--small" />
      <Skeleton className="skeleton-line skeleton-line--hero-title" />
      <Skeleton className="skeleton-line skeleton-line--title" />
      <Skeleton className="skeleton-image skeleton-image--wide" />
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton className="skeleton-line" key={index} />
      ))}
    </div>
  )
}
